const SET_ACTIVITIES = (state, activities) => {
  state.activities = activities
}

const ADD_ACTIVITY = (state, activity) => {
  state.activities.push(activity)
}

const DELETE_ACTIVITY = (state, id) => {
  state.activities = state.activities.filter(s => s.id !== id)
}

const EDIT_ACTIVITY = (state, activity) => {
  state.activities = state.activities.map(s => {
    if (s.id === activity.id) {
      return activity
    } else {
      return s
    }
  })
}

const IS_LOADED = state => {
  state.isLoaded = true
}

export default {
  ADD_ACTIVITY,
  DELETE_ACTIVITY,
  EDIT_ACTIVITY,
  SET_ACTIVITIES,
  IS_LOADED
}
